/* eslint-disable prettier/prettier */
import React from 'react';
import styles from '../../../../styles/components/pageComponents/program/ProgramGoals.module.css';

export interface GoalItem {
	id: string | number;
	title: string;
	goaltype: string;
	description: string;
	targetvalue?: number;
	unit?: string;
}

interface ProgramGoalsProps {
	title?: string;
	goals: GoalItem[];
	onAddGoals?: () => void;
}

const CheckIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 27 27"
		fill="none"
	>
		<path
			d="M25.4983 10.7542C26.0692 13.5559 25.6623 16.4685 24.3456 19.0065C23.0289 21.5444 20.8819 23.5543 18.2627 24.7009C15.6435 25.8475 12.7103 26.0615 9.95244 25.3072C7.19453 24.5529 4.77856 22.876 3.10742 20.556C1.43627 18.236 0.610975 15.4133 0.769153 12.5585C0.92733 9.70367 2.05942 6.98937 3.97663 4.86822C5.89385 2.74707 8.48029 1.3473 11.3046 0.902326C14.129 0.457355 17.0205 0.994084 19.4971 2.42301M9.49706 12.0042L13.2471 15.7542L25.747 3.25426"
			stroke="#147B58"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const ProgramGoals: React.FC<ProgramGoalsProps> = ({
	title = 'Program Goals',
	goals,
	onAddGoals,
}) => {
	const isEmpty = goals.length === 0;

	return (
		<div className={styles.cardContainer}>
			{/* Header section with dynamic line extension */}
			<div className={styles.headerWrapper}>
				<h2 className={styles.heading}>{title}</h2>
				<div className={styles.dividerLine} />
			</div>

			{/* Dynamic list items */}
			<ul className={styles.goalList}>
				{goals.map(goal => (
					<li key={goal.id} className={styles.goalItem}>
						<div className={styles.iconWrapper}>
							<CheckIcon />
						</div>
						<div className={styles.textContent}>
							<h3 className={styles.goalTitle}>
								<h3 className={styles.goalTitle}>
									{`${goal.targetvalue}${goal.unit?.toLowerCase() === "percentage"
											? " %"
											: goal.unit?.toLowerCase() === "hours"
												? " hrs"
												: ""
										} - ${goal.goaltype}`}
								</h3>
							</h3>
							<p className={styles.goalDescription}>
								{goal.description}
							</p>
						</div>
					</li>
				))}
			</ul>
		</div>
	);
};

export default ProgramGoals;
